import { CenteredPage } from '../app/CenteredPage';
import { Button } from '../components/Button';
import { Paper } from '../components/Paper';
import { EmptyState } from '../components/States';
import { signOut } from '../features/auth/session';

export function AccountBanned({ reason }: { reason: string | null }) {
  return (
    <CenteredPage>
      <Paper>
        <EmptyState title="This account has been banned" actions={<Button onClick={() => signOut()}>Sign out</Button>}>
          <p>Moderators removed this account from Roadrunner{reason ? `: “${reason}”` : '.'}</p>
        </EmptyState>
      </Paper>
    </CenteredPage>
  );
}
